import React, { Component, Fragment } from 'react';
import Sidebar from '../navigation/Sidebar';
import Formusers from './Formusers';
import { withRouter } from "react-router-dom";

class Newusers extends Component {
    render() {
        return (
            <Fragment>
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()}   />
                    <div id="content">

                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Crear nuevo usuario</h4>
                                        <Formusers history={this.props.history} />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Newusers);


// WEBPACK FOOTER //
// ./src/components/users/Newusers.js